import store from "./../store/index";

const AuthUtils = {
    /* Returning the permissions of the user. */
    permissions() {
        return _.get(store.state.user, "permissions");
    },
    /* Checking if the user is logged in. */
    loggedIn() {
        return !!store.state.user;
    },
    /* Checking if the user has a role. */
    hasRole(role) {
        if (!store.state.user || !store.state.user.roles) {
            return false;
        }
        if (Array.isArray(role)) {
            let has = false;
            _.forEach(role, (item) => {
                if (!!store.state.user.roles.find((i) => i.role === item)) {
                    has = true;
                    return false;
                }
            });
            return has;
        }
        return !!store.state.user.roles.find((item) => {
            return item.role === role;
        });
    },
    /* Checking if the user has a permission. */
    can(permission) {
        return this.permissions().includes(permission);
    }
};

export default AuthUtils;
